// @react/hooks/useCalendar.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { calendarStore } from '@core/stores';

/**
 * React hook for Calendar operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useCalendar } from '@react/hooks';
 *
 * const CalendarList = observer(() => {
 *   const store = useCalendar();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useCalendar() {
  return calendarStore;
}
